import { render, staticRenderFns } from "./package-summary.vue?vue&type=template&id=6f85bc77&scoped=true"
import script from "./package-summary.vue?vue&type=script&lang=js"
export * from "./package-summary.vue?vue&type=script&lang=js"
import style0 from "./package-summary.vue?vue&type=style&index=0&id=6f85bc77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85bc77",
  null
  
)

export default component.exports